import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import css from '@styled-system/css';
import { variant } from 'styled-system';
import { Box } from '../box';
import { Flex } from '../flex';
const baseCss = css({
    fontSize: 'xl',
    borderRadius: '50%',
});
export const Spinner = styled(Box) `
  ${baseCss}
  position: 'relative';
  width: 1em;
  height: 1em;
  animation: spinnerAnimation 1.1s infinite ease;
  transform: translateZ(0);
  ${({ theme }) => variant({ variants: theme.spinnerVariants, prop: 'size' })}

  @keyframes spinnerAnimation {
    ${({ theme, color }) => {
    let deprecatedColor = undefined;
    if (color === 'light') {
        deprecatedColor = '#ffffff';
    }
    else if (color === 'dark') {
        deprecatedColor = theme.colors.primary;
    }
    const baseColor = deprecatedColor
        ? deprecatedColor
        : theme.colors.spinner;
    const colorOrder = [
        baseColor,
        baseColor + 'D9',
        baseColor + 'B3',
        baseColor + '8C',
        baseColor + '66',
        baseColor + '4C',
        baseColor + '33',
        baseColor + '19',
    ];
    return `
    0%,
    100% {
      box-shadow: 0em -2.6em 0em 0em ${colorOrder[0]},
        1.8em -1.8em 0 0em ${colorOrder[7]},
        2.5em 0em 0 0em ${colorOrder[6]},
        1.75em 1.75em 0 0em ${colorOrder[5]},
        0em 2.5em 0 0em ${colorOrder[4]},
        -1.8em 1.8em 0 0em ${colorOrder[3]},
        -2.6em 0em 0 0em ${colorOrder[2]},
        -1.8em -1.8em 0 0em ${colorOrder[1]};
    }
    12.5% {
      box-shadow: 0em -2.6em 0em 0em ${colorOrder[1]},
        1.8em -1.8em 0 0em ${colorOrder[0]}, 2.5em 0em 0 0em ${colorOrder[7]},
        1.75em 1.75em 0 ${colorOrder[6]},
        0em 2.5em 0 0em ${colorOrder[5]},
        -1.8em 1.8em 0 0em ${colorOrder[4]},
        -2.6em 0em 0 0em ${colorOrder[3]},
        -1.8em -1.8em 0 0em ${colorOrder[2]};
    }
    25% {
      box-shadow: 0em -2.6em 0em 0em ${colorOrder[2]},
        1.8em -1.8em 0 0em ${colorOrder[1]}, 2.5em 0em 0 0em ${colorOrder[0]},
        1.75em 1.75em 0 0em ${colorOrder[7]},
        0em 2.5em 0 0em ${colorOrder[6]},
        -1.8em 1.8em 0 0em ${colorOrder[5]},
        -2.6em 0em 0 0em ${colorOrder[4]},
        -1.8em -1.8em 0 0em ${colorOrder[3]};
    }
    37.5% {
      box-shadow: 0em -2.6em 0em 0em ${colorOrder[3]},
        1.8em -1.8em 0 0em ${colorOrder[2]},
        2.5em 0em 0 0em ${colorOrder[1]}, 1.75em 1.75em 0 0em ${colorOrder[0]},
        0em 2.5em 0 0em ${colorOrder[7]},
        -1.8em 1.8em 0 0em ${colorOrder[6]},
        -2.6em 0em 0 0em ${colorOrder[5]},
        -1.8em -1.8em 0 0em ${colorOrder[4]};
    }
    50% {
      box-shadow: 0em -2.6em 0em 0em ${colorOrder[4]},
        1.8em -1.8em 0 0em ${colorOrder[3]},
        2.5em 0em 0 0em ${colorOrder[2]},
        1.75em 1.75em 0 0em ${colorOrder[1]}, 0em 2.5em 0 0em ${colorOrder[0]},
        -1.8em 1.8em 0 0em ${colorOrder[7]},
        -2.6em 0em 0 0em ${colorOrder[6]},
        -1.8em -1.8em 0 0em ${colorOrder[5]};
    }
    62.5% {
      box-shadow: 0em -2.6em 0em 0em ${colorOrder[5]},
        1.8em -1.8em 0 0em ${colorOrder[4]},
        2.5em 0em 0 0em ${colorOrder[3]},
        1.75em 1.75em 0 0em ${colorOrder[2]},
        0em 2.5em 0 0em ${colorOrder[1]}, -1.8em 1.8em 0 0em ${colorOrder[0]},
        -2.6em 0em 0 0em ${colorOrder[7]},
        -1.8em -1.8em 0 0em ${colorOrder[6]};
    }
    75% {
      box-shadow: 0em -2.6em 0em 0em ${colorOrder[6]},
        1.8em -1.8em 0 0em ${colorOrder[5]},
        2.5em 0em 0 0em ${colorOrder[4]},
        1.75em 1.75em 0 0em ${colorOrder[3]},
        0em 2.5em 0 0em ${colorOrder[2]},
        -1.8em 1.8em 0 0em ${colorOrder[1]}, -2.6em 0em 0 0em ${colorOrder[0]},
        -1.8em -1.8em 0 0em ${colorOrder[7]};
    }
    87.5% {
      box-shadow: 0em -2.6em 0em 0em ${colorOrder[7]},
        1.8em -1.8em 0 0em ${colorOrder[6]},
        2.5em 0em 0 0em ${colorOrder[5]},
        1.75em 1.75em 0 0em ${colorOrder[4]},
        0em 2.5em 0 0em ${colorOrder[3]},
        -1.8em 1.8em 0 0em ${colorOrder[2]},
        -2.6em 0em 0 0em ${colorOrder[1]}, -1.8em -1.8em 0 0em ${colorOrder[0]};
    }
    `;
}}
  }
`;
Spinner.defaultProps = {
    size: 'm',
};
export const SpinnerFullPageContainer = styled(Flex) `
  transform: translate(-50 %, -50 %);
`;
SpinnerFullPageContainer.defaultProps = {
    position: 'absolute',
    top: '50%',
    left: '50%',
};
export const SpinnerFullPage = ({ dataCy = 'loader', ...props }) => {
    // TODO: disable spinner when skeleton context present
    return (_jsx(SpinnerFullPageContainer, { ...props, children: _jsx(Spinner, { "data-cy": dataCy, "data-testid": dataCy }) }));
};
//# sourceMappingURL=data:application/json;base64,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